export default "__VITE_ASSET__B2Cj8elZ__"